import { t } from 'react-switch-lang';
import { isDevelopment, isLocal } from './HostingEnv';

// eslint-disable-next-line import/prefer-default-export
export const setPageTitle = (title) => {
  if (typeof document !== 'undefined') {
    const e = document.getElementById('__next-route-announcer__');
    if (e) e.textContent = `${title} | ${t('OfficialSiteName')}`;
  }
};

/**
 * Moves focus to an element with the specified selector if it is found.
 *
 * - scroll="top": scrolls to top, "none": prevents scrolling, anything else: scrolls to focus.
 * - focusable=false: makes focusable, removes from tab order.
 *
 * @param {string} selector
 * The selector to find the element to focus on.
 * @param {string} [scroll=undefined]
 * Scroll behavior after focusing. Default = undefined.
 * @param {boolean} [focusable=false]
 * Whether the element is focusable. Default = false.
 */
export const moveFocusTo = (selector, scroll = undefined, focusable = false) => {
  if (typeof document === 'undefined') return; // prevent server-side render error
  const el = (selector[0] === '#') ? document.getElementById(selector.slice(1)) : document.querySelector(selector);
  if (el) {
    if (!focusable) el.setAttribute('tabIndex', -1);
    el.focus({ preventScroll: scroll === 'none' });
    if (scroll === 'top') window.scrollTo(0, 0);
  }
};

export function scrollToTop() {
  moveFocusTo('focus-helper', 'top');
}

/**
 * Creates an element with a specified role and appends it to an existing element.
 * These alerts are used by screen readers to notify users something has happened.
 *
 * role = 'alert' - Used for negative announcements (errors, warnings, etc)
 * role = 'status' - Used for positive announcements (successful form submission, etc)
 *
 * @param {any} msg
 * The message that will be read aloud.
 * @param {any} appendTo
 * Where the element will be attached to.
 * @param {any} role
 * Role type (alert or status preferably)
 */
export const setScreenReaderAlert = (msg, role = 'alert', appendTo = document.body) => {
  if (!msg) return;

  const screenreaderAlert = document.createElement('span');
  screenreaderAlert.className = 'visuallyHidden';
  screenreaderAlert.setAttribute('role', role);
  const txtNode = document.createTextNode(msg);
  screenreaderAlert.appendChild(txtNode);
  appendTo.append(screenreaderAlert);

  if (isLocal || isDevelopment) {
    // eslint-disable-next-line no-console
    console.log(`Role with ${role} saying ${msg}`);
  }
};
